import { galleryFilters } from './constants';

export const getCategoryName = key => {
  return galleryFilters.find(({ value }) => value === key)?.name;
};
